var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":_vm.domId}},_vm._l((_vm.viewerData),function(img,index){return _c('li',{key:index},[_c('img',{staticStyle:{"display":"none"},attrs:{"src":img.url,"alt":img.title || '图片'}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }